// extracted by css-extract-rspack-plugin
export default {"cls1":"SourcePaperCard-cls1_ncb","cls2":"SourcePaperCard-cls2_fBf SourcePaperCard-cls1_ncb"};